import { ReactElement } from 'react'
import illustration from '../images/Padasjoki5.jpg'
import StageContent from '../components/StageContent'
import StageTitle from '../components/StageTitle'
import StageText from '../components/StageText'
import StageOptions from '../components/StageOptions'

const options = [
  {
    text: 'Aloita seikkailu alusta',
    gotoStage: 1
  }
]

interface Props {
  onStageChange: (stage: number) => void
}

const PadasjokiStage5 = ({ onStageChange }: Props): ReactElement => {
  return (
    <StageContent illustration={illustration}>
      <StageTitle>Onnittelut, läpäisit pelin</StageTitle>
      <StageText>
        Mainiemen saha on ainutlaatuinen ja maakunnallisesti arvokas rakennettu kulttuuriympäristö. Se on yksi Suomen parhaiten säilyneistä höyrysaha-alue kokonaisuuksista. Tänä päivänä saha toimii upeana ympäristönä myyjäisille, tansseille, konserteille ja erilaisille tapahtumille, kuten lasten Halloween-juhlille tai Venetsialaisille.
      </StageText>
      <StageText>
        Haluatko kuulla lisää tarinoita Padasjoelta? Suunnittele vierailusi ja lue lisää täältä: <a href="https://www.padasjoki.fi/fi" target='_blank'>https://www.padasjoki.fi/fi</a>
      </StageText>
      <StageText>
        <strong>Tiesitkö muuten, että Padasjoen kirkonkylä on valittu Päijät-Hämeen Vuoden Kyläksi 2014!</strong>
      </StageText>
      <StageOptions options={options} onSelect={onStageChange} />
    </StageContent>
  )
}

export default PadasjokiStage5
